import axios from 'axios';

export default axios.create({
    baseURL: 'https://date.nager.at/api/v3/'
});